module.exports = __webpack_public_path__ + "img/Samsung_Pay_KR.e0f47b77.png";